import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import 'animate.css';

// --- CONTEXTOS ---
import { AuthProvider } from './components/context/AuthContext'; 
import { ChatProvider } from './components/context/ChatContext'; // <--- VERIFICA QUE ESTA RUTA SEA CORRECTA

// --- NAVBARS ESPECIALIZADOS ---
import AdminNavbar from './components/admin/AdminNavbar';
import DeliveryNavbar from './components/delivery/DeliveryNavbar';

// Vistas públicas
import ClienteView from './components/cliente/ClienteView';
import RegistroAdminView from './components/admin/RegistroAdminView';
import LoginDeliveryView from './components/delivery/LoginDeliveryView';
import RegistroDeliveryView from './components/delivery/RegistroDeliveryView';
import OpenAdmin from './components/admin/OpenAdmin';
import IntroDeliveryPanel from './components/delivery/IntroDeliveryPanel';
import LandingPage from './components/home/LandingPage';
import SplashScreen from './components/home/SplashScreen'; 

// Paneles protegidos
import AdminPanel from './components/admin/AdminPanel';
import DeliveryPanel from './components/delivery/DeliveryPanel'; 
import PedidosCompletados from './components/admin/PedidosCompletados';

// Protección de rutas
import RutaPrivada from './components/shared/RutaPrivada';

// Componente Splash
const InicioConSplash = () => {
  const [showSplash, setShowSplash] = useState(() => !sessionStorage.getItem('clavelina_splash_visto'));
  const navigate = useNavigate();
  const handleFinishLoading = () => {
    sessionStorage.setItem('clavelina_splash_visto', 'true');
    setShowSplash(false);
  };
  if (showSplash) return <SplashScreen finishLoading={handleFinishLoading} />;
  return <LandingPage onEntrarAlChat={() => navigate('/')} />;
};

function App() {
  return (
    <AuthProvider>
      {/* El ChatProvider envuelve al Router para que el Context esté disponible en todas las vistas */}
      <ChatProvider> 
        <Router>
          <Routes>
            {/* 1. RUTAS PÚBLICAS */}
            <Route path="/inicio" element={<InicioConSplash />} />
            <Route path="/" element={<ClienteView />} />
            <Route path="/admin-intro" element={<OpenAdmin />} />
            <Route path="/delivery-intro" element={<IntroDeliveryPanel />} />
            <Route path="/login-admin" element={<OpenAdmin defaultVista="login" />} />
            <Route path="/login-delivery" element={<LoginDeliveryView />} />
            <Route path="/registro-admin" element={<RegistroAdminView />} />
            <Route path="/registro-delivery" element={<RegistroDeliveryView />} />

            {/* 2. SECCIÓN ADMIN */}
            <Route
              path="/admin/*"
              element={
                <RutaPrivada rolEsperado="admin">
                  <AdminNavbar />
                  <Routes>
                    <Route path="/" element={<AdminPanel />} />
                    <Route path="/completados" element={<PedidosCompletados />} />
                  </Routes>
                </RutaPrivada>
              }
            />

            {/* 3. SECCIÓN DELIVERY */}
            <Route
              path="/delivery/*"
              element={
                <RutaPrivada rolEsperado="delivery">
                  <DeliveryNavbar />
                  <Routes>
                    <Route path="/" element={<DeliveryPanel />} />
                  </Routes>
                </RutaPrivada>
              }
            />
          </Routes>
        </Router>
      </ChatProvider>
    </AuthProvider>
  );
}

export default App;